/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**********************************************!*\
  !*** ./src/assets/js/text-list-show-more.js ***!
  \**********************************************/
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.text-list-show-more--cta')) {
    document.querySelectorAll('.text-list-show-more--cta').forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();

        if (e.target.closest('.text-list-show-more').querySelector('.text-list-show-more__list')) {
          e.target.closest('.text-list-show-more').querySelector('.text-list-show-more__list').classList.toggle('text-list-show-more__list--short');
          e.target.closest('.text-list-show-more').classList.toggle('text-list-show-more--opened');
        }
      });
    });
  }
});
/******/ })()
;